import moment from 'moment';

export const CALLBACK_SLOTS = ['morning', 'midday', 'afternoon'];
export const CALLBACK_MAX_DAYS_AHEAD = 60;

const BERLIN_TIME_ZONE = 'Europe/Berlin';

const berlinDayFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: BERLIN_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

// Built from the parts, not the formatted string, whose order is up to the engine's locale data.
const berlinIsoDay = (now) => {
  const parts = berlinDayFormatter.formatToParts(now);
  const get = (type) => parts.find((part) => part.type === type).value;
  return `${get('year')}-${get('month')}-${get('day')}`;
};

/**
 * Start of the current day in Europe/Berlin (not in the browser's time zone), so a visitor west
 * of Berlin is never offered a "tomorrow" that is already "today" for the callback team.
 * @param {Date} [now]
 * @returns {import('moment').Moment}
 */
export const berlinToday = (now = new Date()) => moment(berlinIsoDay(now), 'YYYY-MM-DD');

/**
 * Earliest (tomorrow) and latest (today + 60 days) selectable callback day, both inclusive.
 * @param {Date} [now]
 * @returns {{ minDate: import('moment').Moment, maxDate: import('moment').Moment }}
 */
export const callbackDateBounds = (now = new Date()) => {
  const today = berlinToday(now);
  return {
    minDate: today.clone().add(1, 'day'),
    maxDate: today.clone().add(CALLBACK_MAX_DAYS_AHEAD, 'days'),
  };
};

/**
 * @param {import('moment').Moment} day
 * @returns {boolean}
 */
export const isWeekend = (day) => day.isoWeekday() > 5;

/**
 * True for a valid moment that is a weekday within the callback bounds (compared by day).
 * @param {unknown} day
 * @param {Date} [now]
 * @returns {boolean}
 */
export const isSelectableCallbackDate = (day, now = new Date()) => {
  if (!moment.isMoment(day) || !day.isValid() || isWeekend(day)) {
    return false;
  }
  const { minDate, maxDate } = callbackDateBounds(now);
  return day.isBetween(minDate, maxDate, 'day', '[]');
};
